import {NotificationInteraction, type NotificationInteractionData} from "@/types/site_admin/notificationInteraction";

export class Maintenance {
  public id:number|null;
  public text:string;
  public email_text:string;
  public email_subject:string;
  public name:string;
  public extra_data: object;
  public client_enabled:boolean;
  public notification_sent:boolean;
  public from:Date|null;
  public until:Date|null;
  public notificationInteractions: NotificationInteraction[];

  constructor(data:MaintenanceData|void) {
    if(data === undefined)
    {
      this.id = null;
      this.text = "";
      this.email_text = "";
      this.email_subject = "";
      this.name = "";
      this.extra_data = {};
      this.client_enabled= false;
      this.notification_sent= false;
      this.from = null;
      this.until = null;
      this.notificationInteractions = [];
    }
    else
    {
      this.id = data.id;
      this.text = data.text;
      this.email_text = data.email_text;
      this.email_subject = data.email_subject;
      this.name = data.name;
      this.client_enabled = data.client_enabled;
      this.extra_data = data.extra_data;
      if(this.extra_data.from){
        this.extra_data.from = new Date(data.extra_data.from)
      }
      if(this.extra_data.until){
        this.extra_data.until = new Date(data.extra_data.until)
      }
      this.notification_sent = data.notification_sent;
      this.from = null;
      if(data.from !== null)
      {
        this.from = new Date(data.from);
      }
      this.until = null;
      if(data.until !== null)
      {
        this.until = new Date(data.until);
      }
      this.notificationInteractions = [];
      if (data.notificationInteractions !== undefined) {
        data.notificationInteractions.forEach(notificationInteraction => this.notificationInteractions.push((new NotificationInteraction(notificationInteraction))));
      }
    }
  }

  public resetToDefaults():void {
    this.id = null;
    this.text = "";
    this.email_text = "";
    this.email_subject = "";
    this.name = "";
    this.extra_data = {};
    this.client_enabled = false;
    this.notification_sent = false;
    this.from = null;
    this.until = null;
  }
}

export type MaintenanceData = {
  id:number|null;
  text:string;
  name:string;
  email_text:string;
  email_subject:string;
  client_enabled:boolean;
  extra_data:object;
  notification_sent:boolean;
  from:Date|null;
  until:Date|null;
  notificationInteractions: NotificationInteractionData[];
}
